// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBOgdLlBwxX4FpIgTVOZwNKeSTclNqjf7o",
    authDomain: "bbq-wings-37ca9.firebaseapp.com",
    projectId: "bbq-wings-37ca9",
    storageBucket: "bbq-wings-37ca9.firebasestorage.app",
    messagingSenderId: "663306802573",
    appId: "1:663306802573:web:d3aee65fcee0a7395c19c4",
    measurementId: "G-GNYNPGL5J1",
    vapidKey: "BBCCp_Rmc6BTNovECVUFYlw86L6WgmJucuOPPxhwHn4iDIdlSpUwD_5mFq7KX0P0Zob39FlSlFsS_BxjOcBvT0k",
  }
};

export const environment2 = {
  production: true,
  backend: {
    baseURL:"https://dashboard.wings.bayonnebbq.com/api/"
  }
};

export const environment3 = {
  production: false,
  authorizeNet: {
    apiLoginId: '8kPp46H4Ac9',
    clientKey: '992e4UDwHm33nYU3'
  },
  apiUrl: 'YOUR_BACKEND_URL'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
